import { captureErrorInSentry } from "./captureErrorInSentry";

export const formatDateString = (dateString: string) => {
  const date = new Date(dateString);
  if (!isNaN(date.valueOf())) return formatDate(date);
  else {
    captureErrorInSentry(
      new Error(
        `formatDateString attempted to parse an invalid date string: ${dateString}`,
      ),
    );
  }
};

export const formatDate = (date: Date) => {
  const { format } = new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
  });
  return format(date);
};
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";